const Spacer = ({ className }: { className?: `h-${number | string}` }) => {
  return <span className={`block ${className ?? "h-8"} shrink-0`}>&nbsp;</span>;
};

export { Spacer };
